/* eslint-disable */
import React from 'react';

import './styles/styles.css';
import background from '../assets/images/trees-background.png';
import SEO from './SEO';
import ReviewCard from './ReviewCard';
import { reviews } from './reviewsData';

const heroWrapperStyle = {
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
};

const heroImageStyle = {
  width: '100%',
  display: 'block',
};

const heroOverlayStyle = {
  position: 'absolute',
  inset: 0,
  background:
    'linear-gradient(to bottom, rgba(0,0,0,0.45), rgba(0,0,0,0.65))',
};

const heroCenteredStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '#FFFFFF',
  textAlign: 'center',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const heroTitleStyle = {
  fontSize: 36,
  fontWeight: 700,
  marginBottom: 8,
};

const heroSubtitleStyle = {
  fontSize: 16,
  opacity: 0.9,
};

const sectionStyle = {
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  padding: '48px 24px',
  color: '#F5F5FA',
};

const innerStyle = {
  maxWidth: 1100,
  margin: '0 auto',
};

const gridStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 18,
  justifyContent: 'center',
  alignItems: 'flex-start',
};

const emptyStyle = {
  textAlign: 'center',
  fontSize: 14,
  opacity: 0.75,
  padding: '40px 0',
};

const Reviews = () => {
  return (
    <>
      <SEO
        title="Reviews | Bins Storage"
        description="Read real customer reviews of Bins Storage — valet pickup, secure storage, and on-time delivery in the Bay Area and Tacoma."
        path="/Reviews"
      />
      <div>
        {/* Hero */}
        <div style={heroWrapperStyle}>
          <img src={background} style={heroImageStyle} alt="Trees background" />
          <div style={heroOverlayStyle} />
          <div style={heroCenteredStyle}>
            <h1 style={heroTitleStyle}>Customer Reviews</h1>
            <p style={heroSubtitleStyle}>
              What people are saying about Bins Storage.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div style={sectionStyle}>
          <div style={innerStyle}>
            {reviews.length === 0 ? (
              <div style={emptyStyle}>No reviews yet.</div>
            ) : (
              <div style={gridStyle}>
                {reviews.map(r => (
                  <ReviewCard key={r.id} review={r} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Reviews;
